export default "__VITE_ASSET__e4a1417f__"